import container from "@src/container";

export const useViewHeadsetStatusTracking = () => {
  const { xApiTrackingService } = container;

  const trackEvent = async (event, options) => {
    event.options = {
      ...options,
      ...event.options,
    };

    await xApiTrackingService.trackEvent(event);
  };

  return {
    trackEvent,
  };
};
